import styled from "styled-components";
import {
    CustomTab,
    CustomerHomePageButtonContainer,
    CustomerHomePageMapContainer,
    CustomerNavigationContainer,
    TabRow
} from "../../customerHomePageWithShiftScore/CustomerHomePageWithShiftScore.styles";

export const PageContent = styled.div`
    width: 100%;
    padding: 0;
    margin-top: 12px;
    margin-bottom: 80px;
`;

export const TabContentSection = styled.div`
    width: 100%;
    margin-top: 20px;
`;

export const ShiftsTopSection = styled(CustomerHomePageButtonContainer)`
    justify-content: space-between;
    gap: 50px;

    @media (max-width: 1235px) {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }
`;

export const ShiftsNavigationContainer = styled(CustomerNavigationContainer)`
    flex: 0 0 auto;
    width: auto;
`;

export const ShiftsMapContainer = styled(CustomerHomePageMapContainer)`
    flex: 0 0 340px;
    width: 340px;
    max-width: 340px;
    margin-left: auto;

    @media (max-width: 1235px) {
        flex: none;
        width: 100%;
        max-width: none;
        margin-left: 0;
    }
`;

export const ShiftsTabRow = styled(TabRow)`
    &.navigation-buttons-row {
        margin-right: 0;
    }
`;

export const ShiftsNavTab = styled(CustomTab)`
    &.navigation-button {
        width: 200px;
        height: 170px;
    }

    .anticon {
        font-size: 20px;
        width: 34px;
        height: 34px;
    }

    > div:last-child {
        > div:first-child {
            font-size: 28px;
        }

        > div:last-child {
            font-size: 14px;
        }
    }
`;

export const ShiftsDateFilterSection = styled.div`
    margin-bottom: 15px;
`;

export const ShiftsDateFilterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 320px;

    .ant-picker {
        width: 100%;
    }

    h5 {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: 600;
        color: #262626;
    }
`;
